# frozen_string_literal: true

require 'lib/publisher'

module View
  class Welcome < Snabberb::Component
    needs :app_route, default: nil, store: true

    def render
      children = [render_notification]
      children << render_introduction
      children << render_buttons

      h('div#welcome.half', children)
    end

    def render_notification
      message = <<~MESSAGE
        <p>This is the playtest server for <strong>Vogel's Scheme of 1870</strong>. Read the <a href='https://docs.google.com/document/d/1lLL6n48GNYh0sBA6JgXMw69S4_IXptF0UIzMQrQj9jk/'>current rules</a>, then create a new game and choose Vogel's Scheme of 1870.</p>
        <p>Vogel's Scheme of 1870 always has the latest rules. Earlier versions stay listed as Vogel's Scheme of 1870 v1, v2 and so on: games keep the rules they started with, and you can still start a game on an older version.</p>
        <p>Found a bug, or something that plays differently from the rules? Tell Josh (designer) or Sasha (developer), with the game's link and what happened.</p>
      MESSAGE

      props = {
        style: {
          background: 'rgb(240, 229, 140)',
          color: 'black',
          marginBottom: '1rem',
        },
        props: {
          innerHTML: message,
        },
      }

      h('div#notification.padded', props)
    end

    def render_introduction
      message = <<~MESSAGE
        <p><strong>This site is separate from 18xx.games.</strong> <a href='/signup'>Create a new account</a> here; your 18xx.games login won't work.</p>
        <p>There are no turn notifications: no emails, and no Discord, Slack or Telegram alerts. Check back here instead; a game is highlighted when it's your turn.</p>
        <p>Password reset emails can't be sent either, so if you forget your password, ask Sasha to reset it.</p>
        <p>New to the site? Check out the <a href='https://github.com/tobymao/18xx/wiki/FAQ'>FAQ</a>, <a href='https://github.com/tobymao/18xx/wiki/Power-User-Features'>keyboard shortcuts</a> and <a href='https://github.com/tobymao/18xx/wiki'>the Wiki</a>.</p>
        <p>Buy physical copies of 18XX games from publishers:</br> #{Lib::Publisher.link_list.join}.</p>
      MESSAGE

      props = {
        style: {
          marginBottom: '1rem',
        },
        props: {
          innerHTML: message,
        },
      }

      h('div#introduction', props)
    end

    def render_buttons
      props = {
        style: {
          margin: '1rem 0',
        },
      }

      create_props = {
        on: {
          click: -> { store(:app_route, '/new_game') },
        },
      }

      tutorial_props = {
        on: {
          click: -> { store(:app_route, '/tutorial?action=1') },
        },
      }

      h('div#buttons', props, [
        h(:button, create_props, 'CREATE A NEW GAME'),
        h(:button, tutorial_props, 'TUTORIAL'),
      ])
    end
  end
end
